export default __webpack_public_path__ + "static/media/art-pro-slt-4.31319129.png";